import React, { Component } from 'react'
import unionClassNames from 'union-class-names'
import { hasAnnotationsEntity } from '../editorUtils'
import AnnotationsModal from './AnnotationModal/index.tsx'
import UpdateRemoveModal from './UpdateRemoveModal'
import AnnotationIcon from './../icons/Annotation'
export const annnotation_type = 'annnotation_type'
export default class InlineToolbarButton extends Component {
  constructor(props) {
    super(props)
    this.onFormStateChange = this.onFormStateChange.bind(this)
  }

  componentDidMount() {
    this.subscribtion = this.props.formSubject.subscribe(this.onFormStateChange)
  }

  componentWillUnmount() {
    this.subscribtion.unsubscribe()
  }

  onFormStateChange(params) {
    if (!params || params.type !== annnotation_type) {
      return
    }
    this.overrideContent(UpdateRemoveModal, params)
  }

  onMouseDown = (event) => {
    event.preventDefault()
  }

  onClick = (e) => {
    e.preventDefault()
    e.stopPropagation()

    this.overrideContent(AnnotationsModal, { type: annnotation_type })
  }

  overrideContent = (NewComponent, params) => {
    const { formSubject, onOverrideContent } = this.props
    setTimeout(() => {
      const content = (props) => (
        <NewComponent
          {...props}
          formSubject={formSubject}
          editParams={params}
          updateInlineToolbar={this.props.store.updateInlineToolbar}
        />
      )
      onOverrideContent(content)
    }, 0)
  }

  render() {
    const { theme, store } = this.props
    const hasLinkSelected = hasAnnotationsEntity(store.getEditorState())
    const className = hasLinkSelected
      ? unionClassNames(theme.button, theme.active)
      : theme.button

    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div className={theme.buttonWrapper} onMouseDown={this.onMouseDown}>
        <button
          className={className}
          type="button"
          onClick={this.onClick}
          data-testid="annotation-btn-toolbar"
        >
          <AnnotationIcon />
        </button>
      </div>
    )
  }
}
